<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>C端数据管理</el-breadcrumb-item>
      <el-breadcrumb-item>选手教师信息</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>

    <!-- 筛选 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">选手教师信息筛选</span>
        </el-col>
      </el-row>
      <el-form
        :model="queryForm"
        class="filter_Form"
        label-width="120px"
        ref="queryFormRef"
      >
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="赛季" prop="season">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="queryForm.season"
                clearable
              >
                <el-option
                  v-for="item in dict_season"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="赛区" prop="districtIdList">
              <el-select
                placeholder="请选择"
                multiple
                style="width: 100%"
                v-model="queryForm.districtIdList"
                clearable
              >
                <el-option
                  v-for="item in dict_district"
                  :key="item.id"
                  :label="item.districtName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="手机号" prop="phone">
              <el-input
                v-model="queryForm.phone"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" type="flex" align="middle">
          <el-col :span="8">
            <el-form-item label="姓名" prop="userName">
              <el-input
                v-model="queryForm.userName"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="学校" prop="schoolId">
              <el-select
                ref="schoolSelectRef"
                style="width: 100%"
                placeholder="请选择"
                v-model="queryForm.schoolId"
                clearable
                filterable
              >
                <el-option
                  v-for="item in schoolList"
                  :key="item.id"
                  :label="item.schoolName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item style="text-align: right;">
              <el-button type="primary" @click="getDataList('search')">查询</el-button>
              <el-button type="primary" plain @click="reset">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <!-- 选手教师信息列表 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col :span="12">
          <span class="title_class">选手教师信息列表</span>
        </el-col>
        <el-col :span="12" style="text-align: right">
          <el-button type="primary" @click="addUserClicked()"
            >新增数据+</el-button
          >
          <el-button
            type="primary"
            plain
            icon="el-icon-download"
            @click="exportTable()"
            >导出数据</el-button
          >
        </el-col>
      </el-row>
      <el-table
        header-cell-class-name="tableHeaderStyle"
        :data="dataList"
        border
        stripe
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="赛季" prop="season"></el-table-column>
        <el-table-column label="赛区" prop="districtName" width="100px"></el-table-column>
        <el-table-column label="账号" prop="phone"></el-table-column>
        <el-table-column label="学生姓名" prop="userName"></el-table-column>
        <!-- <el-table-column
          label="性别"
          prop="sex"
          :formatter="genderFormatter"
        ></el-table-column> -->
        <el-table-column label="学校" prop="schoolName"></el-table-column>
        <el-table-column label="教师身份" prop="parentalIdentity"></el-table-column>
        <el-table-column label="是否免缴费" prop="payd">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.payd" type="success">是</el-tag>
            <el-tag v-else type="danger">否</el-tag>
          </template>
        </el-table-column>
        <!-- <el-table-column label="年级" prop="grade"></el-table-column> -->
        <el-table-column label="备注" prop="note" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="证明文件" prop="proveFile" width="100px">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.proveFile"
              type="text"
              size="small"
              @click="viewProveFile(scope.row.proveFile)"
              style="color: #409eff;"
            >
              <i class="el-icon-view"></i> 查看
            </el-button>
            <span v-else style="color: #999;">未上传</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150px">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="editClicked(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="text"
              size="small"
              style="color: #f56c6c;"
              @click="deleteClicked(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryForm.pageNum"
        :page-sizes="[10, 20, 40, 80]"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 选择新增类型的dialog -->
    <el-dialog
      title="选择新增类型"
      :visible.sync="addTypeSelectDialogVisible"
      width="480px"
      center
      :close-on-click-modal="false"
    >
      <div class="select-type-container">
        <div class="type-card" @click="selectBatchAdd">
          <div class="type-icon">
            <i class="el-icon-upload2"></i>
          </div>
          <div class="type-title">批量新增</div>
          <div class="type-desc">通过Excel模板批量导入选手教师数据</div>
        </div>
        <div class="type-card" @click="selectSingleAdd">
          <div class="type-icon">
            <i class="el-icon-plus"></i>
          </div>
          <div class="type-title">单项新增</div>
          <div class="type-desc">手动填写表单添加单个选手教师</div>
        </div>
      </div>
    </el-dialog>

    <!-- 批量新增的dialog -->
    <el-dialog
      title="批量新增选手教师"
      :visible.sync="batchAddDialogVisible"
      width="600px"
      center
      :close-on-click-modal="false"
    >
      <div class="batch-add-container">
        <div class="batch-steps">
          <el-steps :active="batchStep" align-center>
            <el-step title="下载模板" description="获取导入模板"></el-step>
            <el-step title="上传文件" description="选择填写好的文件"></el-step>
            <el-step title="确认导入" description="检查并确认导入数据"></el-step>
          </el-steps>
        </div>

        <div class="batch-content">
          <!-- 步骤1：下载模板 -->
          <div v-if="batchStep === 0" class="step-content">
            <div class="step-icon">
              <i class="el-icon-download"></i>
            </div>
            <h3>选择导入方式</h3>
            <p style="text-align: left;">您可以先下载模板按格式填写，或者直接上传已准备好的Excel文件。文件内容须为同一赛区、同一学校。</p>
            <div class="template-actions">
              <el-button type="primary" @click="downloadTemplate" icon="el-icon-download">
                下载模板
              </el-button>
              <el-button type="success" @click="skipToUpload" icon="el-icon-upload2">
                直接上传
              </el-button>
            </div>
          </div>

          <!-- 步骤2：上传文件 -->
          <div v-if="batchStep === 1" class="step-content">
            <el-upload
              class="upload-demo"
              drag
              :action="''"
              ref="importExcelRef"
              :auto-upload="false"
              :file-list="uploadFileList"
              :before-upload="beforeUpload"
              :on-change="handleFileChange"
              :on-remove="handleFileRemove"
              :on-exceed="handleFileExceed"
              accept=".xlsx,.xls"
              :limit="1"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击选择文件</em></div>
              <div class="el-upload__tip" slot="tip">只能上传xlsx/xls文件。</div>
              <div class="el-upload__tip" slot="tip" style="color: red;">
                excel导入的信息,如果已经存在,会覆盖原有信息
              </div>

              <!-- 自定义文件列表模板 -->
              <div slot="file" slot-scope="{file}">
                <div class="custom-file-item">
                  <div class="file-info">
                    <i class="el-icon-document file-icon"></i>
                    <span class="file-name">{{ file.name }}</span>
                  </div>
                  <div class="file-actions">
                    <!-- 显示绿色完成图标 -->
                    <i class="el-icon-circle-check success-icon" v-if="file.status === 'ready'"></i>
                    <!-- 移除按钮 -->
                    <i class="el-icon-close remove-icon" @click.stop="removeFile(file)"></i>
                  </div>
                </div>
              </div>
            </el-upload>
          </div>

          <!-- 步骤3：确认导入 -->
          <div v-if="batchStep === 2" class="step-content">
            <p v-if="uploadedFileName">已选择文件：<span class="highlight">{{ uploadedFileName }}</span></p>
            <div class="flex">
              <div class="label">赛季</div>
              <el-select
                placeholder="请选择赛季（必选）"
                v-model="importWordExcel.season"
                clearable
              >
                <el-option
                  v-for="item in dict_season"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </div>
            <div class="flex">
              <div class="label">赛区</div>
              <el-select
                placeholder="请选择赛区（必选）"
                v-model="importWordExcel.districtId"
                clearable
              >
                <el-option
                  v-for="item in dict_district"
                  :key="item.id"
                  :label="item.districtName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
            <div class="flex">
              <div class="label">学校</div>
              <el-select
                placeholder="请选择"
                v-model="importWordExcel.schoolId"
                clearable
                filterable
              >
                <el-option
                  v-for="item in schoolList"
                  :key="item.id"
                  :label="item.schoolName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>

            <el-button type="success" @click="confirmUpload" icon="el-icon-check">
              确认导入
            </el-button>
          </div>
        </div>

        <div class="batch-actions">
          <el-button v-if="batchStep > 0" @click="prevStep">上一步</el-button>
          <el-button v-if="batchStep === 1 && uploadedFileName" type="primary" @click="nextStep">下一步</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 单项新增/编辑的dialog -->
    <el-dialog
      :title="isEditMode ? '编辑选手教师信息' : '单项新增选手教师'"
      :visible.sync="addEditDialogVisible"
      width="700px"
      center
      :close-on-click-modal="false"
      @close="addEditDialogClose"
    >
      <el-form
        :model="addEditForm"
        label-width="120px"
        ref="addEditFormRef"
        :rules="addEditRules"
        class="user-form"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="赛季" prop="season">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="addEditForm.season"
                clearable
              >
                <el-option
                  v-for="item in dict_season"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="赛区" prop="districtId">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="addEditForm.districtId"
                clearable
              >
                <el-option
                  v-for="item in dict_district"
                  :key="item.id"
                  :label="item.districtName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="学生姓名" prop="userName">
              <el-input
                v-model="addEditForm.userName"
                placeholder="请输入姓名"
                prefix-icon="el-icon-user"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="教师身份" prop="parentalIdentity">
              <el-input
                v-model="addEditForm.parentalIdentity"
                placeholder="请输入教师身份"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否免缴费" prop="payd">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="addEditForm.payd"
                clearable
              >
                <el-option label="是" :value="true"></el-option>
                <el-option label="否" :value="false"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        <el-col :span="12">
          <el-form-item label="手机号" prop="phone">
            <el-input
              v-model="addEditForm.phone"
              placeholder="请输入手机号"
              prefix-icon="el-icon-phone"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="学校" prop="schoolId">
            <el-select
              ref="addEditSchoolSelectRef"
              style="width: 100%"
              placeholder="请选择"
              v-model="addEditForm.schoolId"
              clearable
              filterable
            >
              <el-option
                v-for="item in schoolList"
                :key="item.id"
                :label="item.schoolName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
          <el-col :span="12">
            <el-form-item label="备注" prop="note">
              <el-input
                v-model="addEditForm.note"
                placeholder="请输入备注"
              ></el-input>
            </el-form-item>
          </el-col>
      </el-row>
        <el-row :gutter="20">
          <el-col :span="20">
                         <el-form-item label="证明文件:" prop="proveFile">
              <el-upload
               accept="image/jpeg,image/gif,image/png,image/jpg"
               class="upload-demo"
               ref="uploadCoverImgRef"
               action="void"
               :http-request="customUpload"
               :before-upload="beforeProveFileUpload"
               :show-file-list="false"
               :auto-upload="true"
              >
                             <div class="prove-file-upload-area">
                 <el-image
                   v-if="addEditForm.proveFile"
                   style="width: 100px; height: 100px; cursor: pointer;"
                   :src="addEditForm.proveFile"
                   fit="cover"
                   @click.stop="previewProveFile"
                 >
                   <div slot="error" class="image-slot">
                     <i class="el-icon-picture-outline"></i>
                   </div>
                 </el-image>
                 <div v-else class="upload-placeholder">
                   <i class="el-icon-plus avatar-uploader-icon"></i>
                   <div class="upload-text">点击上传证明文件</div>
                 </div>
                 <!-- 删除按钮 -->
                 <div v-if="addEditForm.proveFile" class="upload-actions">
                   <el-button
                     type="text"
                     size="mini"
                     @click.stop="removeProveFile"
                     style="color: #f56c6c;"
                   >
                     <i class="el-icon-delete"></i>
                   </el-button>
                 </div>
               </div>
            </el-upload>
          </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="addEditDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveClicked" icon="el-icon-check">保 存</el-button>
      </span>
    </el-dialog>

    <!-- 删除确认的dialog -->
    <el-dialog
      title="删除确认"
      :visible.sync="deleteDialogVisible"
      width="400px"
      center
      :close-on-click-modal="false"
    >
      <div class="delete-content">
        <div class="delete-icon">
          <i class="el-icon-warning"></i>
        </div>
        <p>确定要删除该选手教师信息吗？</p>
        <el-form label-width="180px" style="margin-top: 20px;">
          <el-form-item label="同步删除免缴费资格">
            <el-select
              placeholder="请选择"
              style="width: 100%"
              v-model="deleteForm.deletePaydType"
              clearable
            >
              <el-option label="是" :value="true"></el-option>
              <el-option label="否" :value="false"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialogVisible = false">取 消</el-button>
        <el-button type="danger" @click="confirmDelete" icon="el-icon-delete">确认删除</el-button>
      </span>
    </el-dialog>

    <!-- 图片预览对话框 -->
    <el-dialog
      title="证明文件预览"
      :visible.sync="previewDialogVisible"
      width="60%"
      center
    >
      <div class="image-preview-container">
        <img :src="previewImageUrl" style="width: 100%; max-height: 500px; object-fit: contain;" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getTeacherChildList, deleteTeacherChild, addTeacherChild, editTeacherChild, getTeacherChildInfo, queryDistrictPage, getAllSchoolList } from '@/http/api'

export default {
  data () {
    return {
      // 对话框显示状态
      addTypeSelectDialogVisible: false,
      batchAddDialogVisible: false,
      addEditDialogVisible: false,
      deleteDialogVisible: false,
      importWordExcel: {
        uploadUrl: this.$env.baseIP + 'sysTeacherChildren/excelImport',
        headerObj: {
          Authorization: localStorage.getItem('Authorization')
        },
        districtId: null,
        season: this.$chnEngStatusCode.defaultSeason,
        schoolId: ''
      },
      uploadProveFileResults: {
        upLoadType: 'proveFile',
        uploadUrl: this.$env.baseIP + 'upload/uploadFileAliOss',
        headerObj: {
          Authorization: localStorage.getItem('Authorization')
        }
      },
      // 批量新增相关
      batchStep: 0,
      uploadedFileName: '',
      selectedFile: null,
      uploadFileList: [],

      // 编辑模式标识
      isEditMode: false,
      currentEditRow: null,

      // 查询表单
      queryForm: {
        season: this.$chnEngStatusCode.defaultSeason,
        districtIdList: [],
        schoolId: '',
        phone: '',
        userName: '',
        pageNum: 1,
        pageSize: 10
      },

      // 新增/编辑表单
      addEditForm: {
        season: this.$chnEngStatusCode.defaultSeason,
        districtId: '',
        userName: '',
        parentalIdentity: '',
        payd: null,
        phone: '',
        schoolId: '',
        note: '',
        proveFile: ''
      },

      // 删除表单
      deleteForm: {
        id: null,
        deletePaydType: null
      },

      // 表单验证规则
      addEditRules: {
        season: [{ required: true, message: '请选择赛季', trigger: 'change' }],
        districtId: [{ required: true, message: '请选择赛区', trigger: 'change' }],
        userName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        parentalIdentity: [{ required: true, message: '请输入教师身份', trigger: 'blur' }],
        payd: [{ required: true, message: '请选择是否免缴费', trigger: 'change' }],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        schoolId: [{ required: true, message: '请选择学校', trigger: 'change' }],
        note: [{ required: true, message: '请输入备注', trigger: 'blur' }]
      },

      // 数据
      dataList: [],
      dict_district: [],
      dict_season: this.$userInfo.getDataList(this, 't_season', this.$store.state.flag).then(value => { this.dict_season = value }),
      schoolList: [],
      total: 0,
      e_sex: this.$userInfo.getDataList(this, 'e_sex').then(value => { this.e_sex = value }),

      // 图片预览相关
      previewDialogVisible: false,
      previewImageUrl: ''
    }
  },
  created () {
    this.getDataList()
    this.getDistrictList()
    this.getSchoolList()
  },
  methods: {
    goBack () {
      this.$router.back()
    },

    // 获取赛区列表
    getDistrictList () {
      queryDistrictPage({ pageNum: 1, pageSize: 10000 }).then((res) => {
        this.dict_district = res.data.list
      }).catch((err) => {
        console.log('err', err)
      })
    },

    // 获取学校列表
    getSchoolList () {
      getAllSchoolList({}).then((res) => {
        this.schoolList = res.data
      }).catch((err) => {
        console.log('返回的err', err)
      })
    },

    // 获取列表信息
    getDataList (getType) {
      if (getType === 'search') {
        this.queryForm.pageNum = 1
        this.queryForm.pageSize = 10
      }
      getTeacherChildList(this.queryForm).then((res) => {
        console.log('getTeacherChildList', res)
        this.dataList = res.data.list
        this.total = res.data.total
      }).catch((err) => {
        console.log('err', err)
      })
    },

    // 重置搜索条件
    reset () {
      this.$refs.queryFormRef.resetFields()
      this.getDataList()
    },

    // 分页相关
    handleSizeChange (newSize) {
      this.queryForm.pageSize = newSize
      this.getDataList()
    },

    handleCurrentChange (newCurPage) {
      this.queryForm.pageNum = newCurPage
      this.getDataList()
    },

    // 性别格式化
    genderFormatter (data) {
      const genderItem = this.e_sex.find(item => item.dictValue === data.sex)
      return genderItem ? genderItem.dictLabel : '未设置'
    },

    // 导出表格
    exportTable () {
      console.log('导出数据')
      const downLoadUrl = `${this.$http.defaults.baseURL}sysTeacherChildren/export?${this.$xcUtils.serialize(this.queryForm)}`
      this.$downLoadFile.downLoadFileWithUrl(this, downLoadUrl)
    },

    // 新增用户点击
    addUserClicked () {
      this.addTypeSelectDialogVisible = true
    },

    // 选择单项新增
    selectSingleAdd () {
      this.addTypeSelectDialogVisible = false
      this.isEditMode = false
      this.addEditDialogVisible = true
    },

    // 选择批量新增
    selectBatchAdd () {
      this.addTypeSelectDialogVisible = false
      this.batchAddDialogVisible = true
    },

    // 下载模板
    downloadTemplate () {
      var downLoadUrl = this.$env.baseIP + 'sysTeacherChildren/downLoadTemplate'
      this.$downLoadFile.downLoadFileWithUrl(this, downLoadUrl, '', {})
      this.$message.success('模板下载成功')
      this.batchStep = 1 // 自动进入下一步
    },

    // 跳过下载直接上传
    skipToUpload () {
      this.batchStep = 1
    },

    // 上传前验证
    beforeUpload (file) {
      const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
                     file.type === 'application/vnd.ms-excel'
      if (!isExcel) {
        this.$message.error('只能上传Excel文件!')
        return false
      }
      return true
    },

    // 证明文件上传
    customUpload (params) {
      console.log('开始上传证明文件:', params)
      this.$upLoadFileRequest.uploadFileResults(
        params, this.uploadProveFileResults
      ).then(value => {
        console.log('上传成功:', value)
        if (value && value.data && value.data.data) {
          this.addEditForm.proveFile = value.data.data
          this.$message.success('证明文件上传成功!')
        } else {
          this.$message.error('上传失败，请重试!')
        }
      }).catch(error => {
        console.error('上传失败:', error)
        this.$message.error('上传失败，请重试!')
      })
    },

    // 批量导入文件选择变化处理
    handleFileChange (file, fileList) {
      console.log('文件变化:', file, fileList)

      if (file.status === 'ready') {
        // 如果已有文件，先清空
        if (this.selectedFile) {
          console.log('检测到已有文件，将进行替换')
        }

        // 设置新文件
        this.selectedFile = file.raw
        this.uploadedFileName = file.name
        this.uploadFileList = fileList
        this.$message.success('文件选择成功，请进入下一步进行确认导入')
      }
      // 注意：removed状态的处理已经移到handleFileRemove方法中
    },

    // 文件移除处理（上传组件自动触发）
    handleFileRemove (file, fileList) {
      console.log('文件被移除:', file)
      // 只清空相关数据，不再调用上传组件的方法，避免循环调用
      this.selectedFile = null
      this.uploadedFileName = ''
      this.uploadFileList = fileList || []
      console.log('文件数据已清空')
    },

    // 文件超出限制时的处理
    handleFileExceed (files, fileList) {
      console.log('文件超出限制，进行替换:', files, fileList)
      this.$message.warning('最多只能上传1个文件，将替换当前文件')

      // 先清空相关数据
      this.selectedFile = null
      this.uploadedFileName = ''
      this.uploadFileList = []

      // 清空现有文件并添加新文件
      if (this.$refs.importExcelRef) {
        this.$refs.importExcelRef.clearFiles()

        // 延迟添加新文件，确保清空操作完成
        setTimeout(() => {
          if (this.$refs.importExcelRef && files && files[0]) {
            this.$refs.importExcelRef.handleStart(files[0])
          }
        }, 50)
      }
    },

    // 删除文件（自定义按钮触发）
    removeFile (file) {
      console.log('自定义删除按钮点击:', file)

      // 直接通过上传组件删除文件，这会自动触发handleFileRemove
      if (this.$refs.importExcelRef) {
        // 使用clearFiles()方法清空所有文件，避免循环调用
        this.$refs.importExcelRef.clearFiles()
      }

      // 清空相关数据
      this.selectedFile = null
      this.uploadedFileName = ''
      this.uploadFileList = []

      this.$message.success('文件已删除')
    },

    // 确认上传
    confirmUpload () {
      // 验证文件是否选择
      if (!this.selectedFile) {
        this.$message.warning('请先选择要上传的文件')
        return
      }
      // 验证赛区是否选择
      if (!this.importWordExcel.districtId) {
        this.$message.warning('请选择赛区')
        return
      }
      // 创建FormData对象进行文件上传
      const formData = new FormData()
      formData.append('file', this.selectedFile)
      formData.append('districtId', this.importWordExcel.districtId)
      formData.append('season', this.importWordExcel.season)
      formData.append('schoolId', this.importWordExcel.schoolId)

      // 使用axios进行文件上传
      this.$http.post(this.importWordExcel.uploadUrl, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          ...this.importWordExcel.headerObj
        }
      }).then(response => {
        console.log('上传成功响应:', response)
        if (response && response.code === 200) {
          this.$message.success('文件上传并导入成功')
          this.closeBatchDialog()
          this.getDataList('search')
        } else {
          this.$message.error(response.msg || '文件导入失败')
        }
      }).catch(error => {
        console.log('上传失败:', error)
        this.$message.error('文件上传失败，请重试')
      })
    },

    // 上一步
    prevStep () {
      if (this.batchStep > 0) {
        this.batchStep--
      }
    },

    // 下一步
    nextStep () {
      if (this.batchStep < 2) {
        this.batchStep++
      }
    },

    // 关闭批量新增弹窗
    closeBatchDialog () {
      this.batchAddDialogVisible = false
      this.batchStep = 0
      this.uploadedDataCount = 0
      this.uploadedFileName = ''
      this.selectedFile = null
      this.uploadFileList = [] // 清空文件列表
      this.importWordExcel.districtId = null
      // 清空上传组件
      if (this.$refs.importExcelRef) {
        this.$refs.importExcelRef.clearFiles()
      }
    },

    // 新增/编辑弹窗关闭
    addEditDialogClose () {
      this.$refs.addEditFormRef.resetFields()
      this.addEditForm = {
        season: this.$chnEngStatusCode.defaultSeason,
        districtId: '',
        userName: '',
        parentalIdentity: '',
        payd: null,
        phone: '',
        schoolId: '',
        note: '',
        proveFile: ''
      }
      this.isEditMode = false
      this.currentEditRow = null
    },

    // 编辑点击
    editClicked (row) {
      this.isEditMode = true
      this.currentEditRow = row

      // 获取用户详情
      getTeacherChildInfo({ id: row.id }).then((res) => {
        console.log('getTeacherChildInfo', res)
        // 回显数据
        this.addEditForm = {
          id: res.data.id,
          season: res.data.season,
          districtId: res.data.districtId,
          userName: res.data.userName,
          parentalIdentity: res.data.parentalIdentity,
          payd: res.data.payd,
          phone: res.data.phone,
          schoolId: res.data.schoolId,
          note: res.data.note || '',
          proveFile: res.data.proveFile || ''
        }

        this.addEditDialogVisible = true
      }).catch((err) => {
        console.log('err', err)
        this.$message.error('获取详情失败')
      })
    },

    // 删除点击
    deleteClicked (row) {
      this.deleteForm.id = row.id
      this.deleteForm.deletePaydType = null
      this.deleteDialogVisible = true
    },

    // 确认删除
    confirmDelete () {
      if (this.deleteForm.deletePaydType === null) {
        this.$message.warning('请选择是否同步删除初、复选免缴费资格')
        return
      }

      deleteTeacherChild({
        id: this.deleteForm.id,
        deletePaydType: this.deleteForm.deletePaydType
      }).then((res) => {
        console.log('deleteTeacherChild', res)
        this.$message.success('删除成功')
        this.deleteDialogVisible = false
        this.getDataList('search')
      }).catch((err) => {
        console.log('err', err)
        this.$message.error('删除失败')
      })
    },

    // 保存点击
    saveClicked () {
      this.$refs.addEditFormRef.validate(valid => {
        if (!valid) return

        const apiCall = this.isEditMode ? editTeacherChild : addTeacherChild
        const apiName = this.isEditMode ? 'editTeacherChild' : 'addTeacherChild'

        apiCall(this.addEditForm).then((res) => {
          console.log(apiName, res)
          this.$message.success(this.isEditMode ? '编辑成功' : '新增成功')
          this.addEditDialogVisible = false
          this.getDataList('search')
        }).catch((err) => {
          console.log('err', err)
          this.$message.error(this.isEditMode ? '编辑失败' : '新增失败')
        })
      })
    },

    // 证明文件上传前验证
    beforeProveFileUpload (file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg'
      const isLt10M = file.size / 1024 / 1024 < 10

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG/PNG 格式!')
        return false
      }
      if (!isLt10M) {
        this.$message.error('上传图片大小不能超过 10MB!')
        return false
      }
      return true
    },

    // 预览证明文件
    previewProveFile () {
      this.previewImageUrl = this.addEditForm.proveFile
      this.previewDialogVisible = true
    },

    // 删除证明文件
    removeProveFile () {
      this.$confirm('确认删除证明文件吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.addEditForm.proveFile = ''
        this.$message.success('删除成功!')
      }).catch(() => {
        // 用户取消删除
      })
    },

    // 查看证明文件（从表格点击）
    viewProveFile (fileUrl) {
      this.previewImageUrl = fileUrl
      this.previewDialogVisible = true
    }
  }
}
</script>

<style lang="less" scoped>
/* 选择类型弹窗样式 */
.select-type-container {
  display: flex;
  gap: 20px;
  padding: 20px 0;
}

.type-card {
  flex: 1;
  padding: 30px 20px;
  border: 2px solid #e6e6e6;
  border-radius: 12px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #fafafa;
}

.type-card:hover {
  border-color: #409eff;
  background: #ecf5ff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.15);
}

.type-icon {
  font-size: 48px;
  color: #409eff;
  margin-bottom: 15px;
}

.type-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 8px;
}

.type-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.4;
}

/* 批量新增弹窗样式 */
.batch-add-container {
  padding: 20px 0;
}

.batch-steps {
  margin-bottom: 10px;
}

.batch-content {
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.step-content {
  text-align: center;
  max-width: 400px;
}

.step-icon {
  font-size: 64px;
  color: #409eff;
  margin-bottom: 0px;
}

.step-content h3 {
  font-size: 20px;
  color: #333;
  margin-bottom: 10px;
}

.step-content p {
  font-size: 14px;
  color: #666;
  margin-bottom: 5px;
  line-height: 1.5;
}

.highlight {
  color: #409eff;
  font-weight: bold;
}

.batch-actions {
  text-align: center;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.template-actions {
  display: flex;
  gap: 15px;
  justify-content: center;
  margin-top: 20px;
}

.template-actions .el-button {
  min-width: 120px;
}

/* 删除确认弹窗样式 */
.delete-content {
  text-align: center;
  padding: 20px 0;
}

.delete-icon {
  font-size: 64px;
  color: #f56c6c;
  margin-bottom: 15px;
}

.delete-content p {
  font-size: 16px;
  color: #333;
  margin-bottom: 0;
}

/* 上传组件样式 */
.upload-demo {
  margin: 20px 0;
}

::v-deep .el-upload-dragger {
  width: 100%;
  padding: 10px;
  border: 2px dashed #d9d9d9;
  border-radius: 6px;
  background: #fafafa;
  transition: all 0.3s ease;
}

::v-deep .el-upload-dragger:hover {
  border-color: #409eff;
  background: #ecf5ff;
}

::v-deep .el-upload-dragger .el-icon-upload {
  font-size: 48px;
  color: #c0c4cc;
  margin-bottom: 16px;
}

::v-deep .el-upload__text {
  color: #606266;
  font-size: 14px;
}

::v-deep .el-upload__text em {
  color: #409eff;
  font-style: normal;
}

/* 通用样式 */
.title_row {
  margin-bottom: 20px;
}

.title_class {
  font-size: 16px;
  // font-weight: bold;
  color: #333;
}

.filter_Form {
  margin-bottom: 20px;
}

/* 自定义文件列表样式 */
.custom-file-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  margin: 8px 0;
  background: #f8f9fa;
  border: 1px solid #e6e6e6;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.custom-file-item:hover {
  background: #ecf5ff;
  border-color: #409eff;
}

.file-info {
  display: flex;
  align-items: center;
  flex: 1;
}

.file-icon {
  font-size: 18px;
  color: #409eff;
  margin-right: 8px;
}

.file-name {
  font-size: 14px;
  color: #333;
  word-break: break-all;
}

.file-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.success-icon {
  font-size: 18px;
  color: #67c23a;
  animation: success-bounce 0.6s ease;
}

.remove-icon {
  font-size: 16px;
  color: #f56c6c;
  cursor: pointer;
  padding: 2px;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.remove-icon:hover {
  background: #f56c6c;
  color: white;
}

@keyframes success-bounce {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

/* 证明文件上传样式 */
.prove-file-upload-area {
  position: relative;
  width: 100px;
  height: 100px;
  border: 2px dashed #d9d9d9;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #fafafa;
}

.prove-file-upload-area:hover {
  border-color: #409eff;
  background: #ecf5ff;
}

.upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  margin-bottom: 5px;
}

.upload-text {
  font-size: 12px;
  color: #8c939d;
  text-align: center;
  line-height: 1.2;
}

.upload-actions {
  position: absolute;
  top: -8px;
  right: -8px;
  background: white;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 30px;
}

.image-preview-container {
  text-align: center;
  background: #f5f5f5;
  border-radius: 4px;
  padding: 20px;
}

/* Element UI上传组件覆盖样式 */
::v-deep .upload-demo .el-upload {
  border: none !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

::v-deep .upload-demo .el-upload:hover {
  border-color: transparent !important;
}

/* 响应式适配 */
@media (max-width: 768px) {
  .select-type-container {
    flex-direction: column;
  }

  .type-card {
    margin-bottom: 15px;
  }
}

.flex{
  display: flex;
  align-items: center;
  margin: 20px 0;
  .label{
    width: 100px;
  }
}
</style>
